<template>
  <select :name="name" class="form-control m-select2" :id="id" :value="value">
  </select>
</template>
<script>
import { es, pt } from '@/plugins/select2/language'
export default {
  name: 's-select2',
  props: {
    data: { default: [], type: Array },
    clear_select: { default: false, type: Boolean },
    id: { default: '', type: String },
    value: { default: '' },
    name: { default: '', type: String },
    placeholder: { default: 'select_an_option', type: String },
    minimumInput: { default: 0, type: Number }
  },
  methods: {
    init (data = []) {
      function matchCustom (params, data) {
        // Always return the object if there is nothing to compare
        if ($.trim(params.term) === '') {
          return data
        }
        let original = data.text.toUpperCase()
        let term = params.term.toUpperCase()
        // Check if the text contains the term
        if (original.indexOf(term) > -1) {
          return data
        }
        // Do a recursive check for options with children
        if (data.children && data.children.length > 0) {
          // Clone the data object if there are children
          // This is required as we modify the object to remove any non-matches
          let match = $.extend(true, {}, data)
          // Check each child of the option
          for (let c = data.children.length - 1; c >= 0; c--) {
            let child = data.children[c]
            let matches = matchCustom(params, child)
            // If there wasn't a match, remove the object in the array
            if (matches == null) {
              match.children.splice(c, 1)
            }
          }
          // If any children matched, return the new object
          if (match.children.length > 0) {
            return match
          }
          // If there were no matching children, check just the plain object
          return matchCustom(params, match)
        }
        // If it doesn't contain the term, don't return anything
        return null
      }
      const self = this
      window.$(this.$el)
        .select2({
          allowclear: true,
          placeholder: this.$options.filters.capitalize(this.placeholder),
          tags: false,
          data: data,
          matcher: matchCustom,
          minimumInputLength: this.minimumInput,
          language: this.$i18n.locale === 'es' ? es : this.$i18n.locale === 'pt' ? pt : '',
          width: '70%'
        })
        .val(this.value)
        .trigger('change')
        .on('change', function () {
          self.$emit('input', this.value)
        })
    }
  },
  mounted () {
    this.init(this.data)
  },
  destroyed () {
    window.$(this.$el).off().select2('destroy')
  },
  watch: {
    value (newVal, oldVal) {
      window.$(this.$el).val(newVal)
    },
    data (newVal, oldVal) {
      this.init(newVal)
    },
    clear_select (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        window.$(`#${this.id}`).val('').trigger('change')
      }
    }
  }
}
</script>
<style>
</style>





// WEBPACK FOOTER //
// select2.vue